import env from "@/configs/env/config";
const FULL_PREFIX_API_END_POINT = "/" + env.API_ENDPOINT_PREFIX_ADMIN;

export default {
  doLogin: FULL_PREFIX_API_END_POINT + "/admin-dologin",
  doLogout: FULL_PREFIX_API_END_POINT + "/admin-dologout",
  resetNotification: FULL_PREFIX_API_END_POINT + "/admin-resetnotification",
  resetPassword: FULL_PREFIX_API_END_POINT + "/admin-resetpassword",
  getOrderList: FULL_PREFIX_API_END_POINT + "/admin-getorderlist",
  getOrder: FULL_PREFIX_API_END_POINT + "/admin-getorder",
  changeOrderStatus: FULL_PREFIX_API_END_POINT + "/admin-changeorderstatus",
  editDiscount: FULL_PREFIX_API_END_POINT + "/admin-editdiscount",
  downloadOrders: FULL_PREFIX_API_END_POINT + "/admin-downloadorders",
  getCouponList: FULL_PREFIX_API_END_POINT + "/admin-getcouponlist",
  uploadShippedData: FULL_PREFIX_API_END_POINT + "/admin-uploadshippeddata",
  getDiscountList: FULL_PREFIX_API_END_POINT + "/admin-getdiscountlist",

  //FRONT END API
  changeShopMode: FULL_PREFIX_API_END_POINT + "/changeshopmode",
  getUsrTemplateList: FULL_PREFIX_API_END_POINT + "/getusrtemplatelist",
  uploadReceiverList: FULL_PREFIX_API_END_POINT + "/uploadreceiverlist",
  continueOrder: FULL_PREFIX_API_END_POINT + "/continueorder",
  getPostcards: FULL_PREFIX_API_END_POINT + "/getpostcards",
  searchAddress: FULL_PREFIX_API_END_POINT + "/searchaddress",
  getPrefectures: FULL_PREFIX_API_END_POINT + "/getprefectures",
  downloadOrderSlip: FULL_PREFIX_API_END_POINT + "/downloadorderslip",
  inputOrdererInformation:
    FULL_PREFIX_API_END_POINT + "/inputordererinformation",
  updatePrintContens: FULL_PREFIX_API_END_POINT + "/updateprintcontens",
  getCategoryDefinitions:
    FULL_PREFIX_API_END_POINT + "/admin-getcategorydefinitions",
  reorderEntry: FULL_PREFIX_API_END_POINT + "/reorderentry",
  getOrderedImage: FULL_PREFIX_API_END_POINT + "/getorderedimage",
  getTermsOfService: FULL_PREFIX_API_END_POINT + "/gettermsofservice",
  showOrderImage: FULL_PREFIX_API_END_POINT + "/showorderimage",
  getPriceInformation: FULL_PREFIX_API_END_POINT + "/getpriceinformation",
  storePayment: FULL_PREFIX_API_END_POINT + "/storepayment",
  productGenerate: FULL_PREFIX_API_END_POINT + "/product/generate",
  editDataUploadUrl: FULL_PREFIX_API_END_POINT + "/editdata/uploadurl",
  updatePrintOrder: FULL_PREFIX_API_END_POINT + "/updateprintorder",
  getOrdererInfomation: FULL_PREFIX_API_END_POINT + "/getordererinfomation",
  getCashOnDelivery: FULL_PREFIX_API_END_POINT + "/getcashondelivery",
  cashOnDeliverySettlement:
    FULL_PREFIX_API_END_POINT + "/cashondeliverysettlement",
  getOrderNo: FULL_PREFIX_API_END_POINT + "/getorderno",
  getpriceconfirminformation: FULL_PREFIX_API_END_POINT + '/getpriceconfirminformation',
};
